import { AbstructLang } from "../../../general/general-component/abstruct-component/AbstructLang";

export default function ItemsWarehouse() {
  const { translate } = AbstructLang();

  const itemsWarehouse = [
    {
      title: translate("warehouses"),
      icon: "fa-solid fa-warehouse",
      url: "/warehouses",
      id: 1,
    },
    {
      title: translate("products"),
      icon: "fa-solid fa-cube",
      url: "/materials",
      id: 2,
    },
    {
      title: translate("suppliers"),
      icon: "fa-solid fa-truck",
      url: "/supplier",
      id: 3,
    },
    {
      title: translate("requests"),
      icon: "fa-solid fa-file-alt",
      url: "/requests",
      id: 4,
    },
  ];
  return {
    itemsWarehouse,
  };
}
/*

{
            title: translate('purchases'),
            icon: "fa-solid fa-shopping-cart",
            url: ""
        },
        {
            title: translate('inventory'),
            icon: "fa-solid fa-boxes",
            url: ""
        },
        {
            title: translate('Reports'),
            icon: "fa-solid fa-chart-bar",
            url: ""
        },
        {
            title: translate('Configration'),
            icon: "fa-solid fa-cog",
            url: ""
        }

        */
